<template>
  <v-row class="ma-0 pa-0">
    <table-management></table-management>
    <photos-management
      v-on:setPhotos="setPhotos"
      :sectionPhotos="sectionPhotos"
    ></photos-management>
    <v-col cols="4" class="ma-0 pa-0">
      <v-btn-toggle>
        <v-btn @click="formatButtonClick('bold')">
          <v-icon>{{ mdiFormatBold }}</v-icon>
        </v-btn>
        <v-btn @click="formatButtonClick('underline')">
          <v-icon>{{ mdiFormatUnderline }}</v-icon>
        </v-btn>
        <v-btn @click="formatButtonClick('italic')">
          <v-icon>{{ mdiFormatItalic }}</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-col>
    <v-col cols="8" class="ma-0 pa-0">
      <v-pagination
        v-model="page"
        :length="Math.ceil(sections.length / 5)"
      ></v-pagination>
    </v-col>
    <v-col
      v-for="(section, index) in paginatedSections"
      :key="index + 'section-management'"
      class="ma-0 pa-0"
      cols="12"
    >
      <v-divider v-if="index !== 0"></v-divider>
      <v-row class="ma-0 pa-0 my-5">
        <v-col class="ma-0 pa-0" cols="2">
          <v-select
            :items="
              [0, 1].includes(index) && page == 1
                ? [styleTypes[index]]
                : styleTypes
            "
            :disabled="
              ([0, 1].includes(index) && page == 1) ||
              [6, 5].includes(section.style)
            "
            :value="section.style"
            v-model="section.style"
            hide-details
            @change="changeSection(index + (page - 1) * 5, section.style)"
            filled
            class="ma-0 pa-0"
            dense
            outlined
          ></v-select>
        </v-col>
        <v-col class="ma-0 pa-0 px-2" cols="6">
          <v-textarea
            :disabled="section.style === 5"
            v-bind:id="`section-management-input-${index}`"
            auto-grow
            rows="1"
            type="text"
            hide-details
            class="ma-0 pa-0"
            light
            dense
            color="primary"
            :value="section.text"
            v-model="section.text"
            outlined
            @keydown="inputKeyDown"
            @focus="focusRow(index)"
            :placeholder="
              section.style === 6
                ? 'Legenda (Opcional)'
                : section.style === 5
                ? 'Inserir tabela'
                : section.style === 8
                ? 'Link (url) Vimeo'
                : 'Inserir texto'
            "
          ></v-textarea>
        </v-col>
        <v-col class="ma-0 pa-0" cols="1">
          <v-row class="ma-0 pa-0" justify="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  :disabled="[0, 1].includes(index) && page == 1"
                  @click="removeSection(index + (page - 1) * 5)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary">{{ mdiTrashCanOutline }}</v-icon>
                </v-btn>
              </template>
              <span>Deletar</span>
            </v-tooltip>
          </v-row>
        </v-col>
        <v-col class="ma-0 pa-0" cols="1">
          <v-row class="ma-0 pa-0" justify="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :disabled="[0, 1].includes(index) && page == 1"
                  icon
                  @click="addRowBefore(index + (page - 1) * 5)"
                >
                  <v-icon color="primary">{{ mdiTableRowPlusBefore }}</v-icon>
                </v-btn>
              </template>
              <span>Adicionar linha acima</span>
            </v-tooltip>
          </v-row>
        </v-col>
        <v-col class="ma-0 pa-0" cols="1">
          <v-row class="ma-0 pa-0" justify="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :disabled="index == 0 && page == 1"
                  icon
                  @click="addRowAfter(index + (page - 1) * 5)"
                >
                  <v-icon color="primary">{{ mdiTableRowPlusAfter }}</v-icon>
                </v-btn>
              </template>
              <span>Adicionar linha abaixo</span>
            </v-tooltip>
          </v-row>
        </v-col>
        <v-col v-if="section.style === 6" class="ma-0 pa-0" cols="1">
          <v-row class="ma-0 pa-0" justify="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  @click="addPhotos(index + (page - 1) * 5)"
                >
                  <v-icon color="primary">{{ mdiImageMultiple }}</v-icon>
                </v-btn>
              </template>
              <span>Adicionar fotos</span>
            </v-tooltip>
          </v-row>
        </v-col>
        <v-col v-if="[3, 4].includes(section.style)" class="ma-0 pa-0" cols="1">
          <v-row class="ma-0 pa-0" justify="center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  @click="addReferences(index + (page - 1) * 5)"
                >
                  <v-icon color="primary">{{ mdiTextBoxPlusOutline }}</v-icon>
                </v-btn>
              </template>
              <span>Adicionar referências a este item</span>
            </v-tooltip>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import TableManagement from "@/components/management/TableManagement.vue";
import PhotosManagement from "@/components/management/PhotosManagement.vue";
import {
  mdiTrashCanOutline,
  mdiTableRowPlusAfter,
  mdiTableRowPlusBefore,
  mdiTextBoxPlusOutline,
  mdiImageMultiple,
  mdiFormatBold,
  mdiFormatItalic,
  mdiFormatUnderline,
} from "@mdi/js";
const constants = {
  ERROR_ADD_SUBITEM: 'É necessário criar um "Item" antes de um "Sub Item".',
  ERROR_DELETE_ITEM:
    "Remova todos os sub itens associados a este item para deleta-lo.",
};
export default {
  methods: {
    ...mapMutations("management", [
      "setFinalTable",
      "setTableModal",
      "setPhotosModel",
    ]),
    ...mapActions("general", ["showError"]),
    formatButtonClick(format) {
      const formatOptions = {
        bold: "<b></b>",
        underline: "<u></u>",
        italic: "<i></i>",
      };
      let el = document.getElementById(
        `section-management-input-${this.lastFocusedRow}`
      );
      if (
        ![3, 4].includes(
          this.sections[this.lastFocusedRow + (this.page - 1) * 5].style
        )
      ) {
        alert("A formatação só está disponível em itens e sub itens.");
        return;
      }
      el.value = el.value + formatOptions[format];
      this.sections[this.lastFocusedRow + (this.page - 1) * 5].text +=
        formatOptions[format];
    },
    focusRow(index) {
      this.lastFocusedRow = index;
    },
    inputKeyDown(evt) {
      if (evt.key === "Enter") {
        const prefix = "section-management-input-";
        const index = new Number(evt.srcElement.id.replace(prefix, ""));
        if (index == 0 && this.page == 1) {
          evt.preventDefault();
          return;
        }
        this.addRowAfter(index + (this.page - 1) * 5);
        setTimeout(
          function () {
            document
              .getElementById(prefix + (index == 4 ? 0 : index + 1))
              .focus();
          }.bind(this),
          10
        );
        evt.preventDefault();
      }
      this.setSections();
    },
    setSections() {
      setTimeout(
        function () {
          this.$emit("setSections", this.sections);
        }.bind(this),
        10
      );
    },
    addRowAfter(index) {
      this.addRowBefore(index + 1);
      this.setSections();
      if ((index + 1) % 5 == 0) {
        this.page++;
        setTimeout(
          function () {
            const prefix = "section-management-input-";
            document.getElementById(prefix + "0").focus();
          }.bind(this),
          10
        );
      }
    },
    addRowBefore(index) {
      this.sections.splice(index, 0, {
        style: this.sections[index - 1].style == 4 ? 4 : 3,
        text: "",
      });
      this.setSections();
    },
    removeSection(index) {
      if (
        this.sections[index].style == 3 &&
        this.sections[index + 1] &&
        this.sections[index + 1].style == 4
      ) {
        this.showError(this.constants.ERROR_DELETE_ITEM);
        return;
      }
      this.sections.splice(index, 1);
      this.setSections();
      if (!this.paginatedSections.length) {
        this.page--;
      }
    },
    changeSection(index, style) {
      if (style == 4 && ![3, 4].includes(this.sections[index - 1].style)) {
        setTimeout(
          function () {
            this.sections[index].style = 3;
          }.bind(this),
          10
        );
        this.showError(this.constants.ERROR_ADD_SUBITEM);
        return;
      }
      if (style == 5) {
        this.rowIndex = index;
        this.setTableModal(true);
      }
      if (style == 6) {
        this.addPhotos(index);
      }
      this.setSections();
    },
    addPhotos(index) {
      this.rowIndex = index;
      this.sectionPhotos = this.sections[this.rowIndex]["photos"] || [];
      this.setPhotosModel(true);
    },
    addReferences(index) {
      this.sections[index]["references"] =
        this.sections[index]["references"] || [];
      this.$emit("addReferencesToSection", {
        index,
        references: this.sections[index]["references"],
      });
    },
    referencesSelection({ index, references }) {
      this.sections[index]["references"] = references;
      this.setSections();
    },
    editReferences(reference) {
      for (let index in this.sections) {
        if (this.sections[index].references) {
          for (let refIndex in this.sections[index].references) {
            if (this.sections[index].references[refIndex].id == reference.id) {
              this.sections[index].references[refIndex] = reference;
            }
          }
        }
      }
      this.setSections();
    },
    deleteReferences(id) {
      for (let index in this.sections) {
        if (this.sections[index].references) {
          this.sections[index].references = this.sections[
            index
          ].references.filter((ref) => {
            return ref.id != id;
          });
        }
      }
      this.setSections();
    },
    setPhotos(photos) {
      this.sections[this.rowIndex]["photos"] = photos;
      this.sections[this.rowIndex]["text"] =
        this.sections[this.rowIndex]["text"] || "";
      this.sectionPhotos = photos;
      this.setSections();
    },
  },
  components: {
    "table-management": TableManagement,
    "photos-management": PhotosManagement,
  },
  computed: {
    ...mapGetters("management", ["finalTable", "tableModal"]),
    paginatedSections() {
      let arr = [];
      let index = (this.page - 1) * 5;
      const finalIndex =
        this.page * 5 > this.sections.length
          ? this.sections.length
          : this.page * 5;
      try {
        for (index; index < finalIndex; index++) {
          arr.push(this.sections[index]);
        }
      } catch {
        return [];
      }
      return arr;
    },
  },
  watch: {
    finalTable(val) {
      if (val && val.name) {
        this.sections[this.rowIndex]["text"] = val.name;
        this.sections[this.rowIndex]["table"] = val;
        this.setTableModal(false);
        this.setSections();
      }
    },
    tableModal(val) {
      if (!val) {
        if (!this.sections[this.rowIndex]["table"]) {
          this.sections[this.rowIndex]["style"] = 1;
        }
        this.rowIndex = null;
      }
    },
    sectionsArray(val) {
      this.sections = val;
    },
  },
  created() {
    this.setFinalTable(null);
    this.sections = this.sectionsArray;
  },
  props: {
    sectionsArray: {
      default: [
        { style: 0, text: "" },
        { style: 1, text: "" },
      ],
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      sections: null,
      styleTypes: [
        { text: "Macro Título", value: 0 },
        { text: "Título", value: 1 },
        { text: "Seção", value: 2 },
        { text: "Item", value: 3 },
        { text: "Sub Item", value: 4 },
        { text: "Tabela", value: 5 },
        { text: "Fotos", value: 6 },
        { text: "Parágrafo", value: 7 },
        { text: "Vídeo", value: 8 },
      ],
      mdiTrashCanOutline,
      mdiTableRowPlusAfter,
      mdiImageMultiple,
      mdiTableRowPlusBefore,
      mdiTextBoxPlusOutline,
      mdiFormatBold,
      mdiFormatItalic,
      mdiFormatUnderline,
      rowIndex: null,
      constants,
      sectionPhotos: [],
      page: 1,
      lastFocusedRow: 0,
    };
  },
};
</script>
